import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAzZWtO4idbE_qz_-GWJ45in8QAkus6ovo",
  authDomain: "tarteeb-store.firebaseapp.com",
  projectId: "tarteeb-store",
  storageBucket: "tarteeb-store.appspot.com",
  messagingSenderId: "810930116957",
  appId: "1:810930116957:web:679a4fc98d666bee8c30b4",
  measurementId: "G-ZSSS51YJYY",
};

firebase.initializeApp(firebaseConfig);

export default firebase.firestore();